import React from "react";
import { CheckIcon, GiftIcon, InfoIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { bonuses } from "../data/bonuses";
export function BonusesSection() {
  return <Section tone="cream" labelledBy="bonuses-title" cta="Yes, I want all 5 bonuses" data-id="element-67" data-mp="vt61nw62f4mg">
      <SectionHeading id="bonuses-title" eyebrow="Included with your purchase" title={<>
            Get These 5 Professional Bonuses <span className="text-cta" data-id="element-69" data-mp="14rhpxrjglqbq">FREE</span>
          </>} sub="Five additional resources to help you get more from the Blueprint. These bonuses are included with the $27 purchase." data-id="element-68" data-mp="qt9xnwxdbd6w" />

      <div className="mt-12 space-y-16 md:space-y-20" data-id="element-70" data-mp="1el8c2ps45oo9">
        {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-71" data-mp="19mdt9nu5c045" data-mpi={i}>
            <div className={`-mx-4 sm:-mx-6 md:mx-0 ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-72" data-mp="1nhzj1x87enxm">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-73" data-mp="1jkbfk5sg3mu4" />
            </div>
            <div data-id="element-74" data-mp="3trnjjjf7xmad">
              <span className="inline-flex items-center gap-2 rounded-full bg-navy px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-gold-light" data-id="element-75" data-mp="3tr5ebxakvxqb">
                <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-76" data-mp="2nytxy07zl6j" />
                Bonus #{b.number}
              </span>
              <h3 className="mt-4 font-serif text-[1.7rem] font-bold leading-tight text-ink sm:text-3xl" data-id="element-77" data-mp="ckbnmvvrlz1a">{b.title}</h3>
              <p className="mt-2 font-serif text-lg italic text-navy" data-id="element-78" data-mp="gkc0wd74o46r">{b.tagline}</p>
              <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-muted sm:text-base" data-id="element-79" data-mp="lblqxewl99j6">
                {b.body.map(p => <p key={p} data-id="element-80" data-mp="qaoxj3s7vnt9">{p}</p>)}
              </div>
              {b.formula && <p className="mt-4 rounded-xl bg-navy px-4 py-3 text-center text-sm font-bold uppercase tracking-wider text-gold-light" data-id="element-81" data-mp="vc4hstmklqal">
                  {b.formula}
                </p>}
              {b.items && <>
                  <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-gold-dark" data-id="element-82" data-mp="5mnvrojlqo20">{b.listLabel}:</p>
                  <ul className="mt-3 space-y-2" data-id="element-83" data-mp="kc3kz03hilfl">
                    {b.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-84" data-mp="fjahefjr5j53">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="tap1yqtb5se9" />
                        <span data-id="element-86" data-mp="oc3zsluhwyn6">{item}</span>
                      </li>)}
                  </ul>
                </>}
              {b.note && <p className="mt-4 flex gap-2 text-[13px] leading-relaxed text-muted" data-id="element-87" data-mp="yajsuud32hzb">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-88" data-mp="350rd2bdt7waq" />
                  {b.note}
                </p>}
              <p className="mt-5 inline-flex items-center gap-3 rounded-xl border border-line bg-white px-4 py-2.5 text-sm" data-id="element-89" data-mp="3040xrq9tx4qd">
                <span className="text-muted" data-id="element-90" data-mp="1fmi1mk3v843c">
                  Reference value <s data-id="element-91" data-mp="1kip7kcw9hfla">{b.value} USD</s>
                </span>
                <span className="font-extrabold uppercase text-cta" data-id="element-92" data-mp="15uuf8xm61d8q">Today: Free</span>
              </p>
            </div>
          </article>)}
      </div>

      <p className="mx-auto mt-12 max-w-2xl text-center text-xs leading-relaxed text-muted" data-id="element-93" data-mp="1arce5gutehd5">
        Individual values shown for the bonuses are proposed reference values.
      </p>
    </Section>;
}